import { COMPANY_NAME, COMPANY_REGION, COMPANY_SHORT, COMPANY_LOCATION, PROFILE_FACTS } from '../constants';

function HeroSection() {
  return (
    <section className="relative overflow-hidden bg-cream">
      <div
        aria-hidden
        className="pointer-events-none absolute -left-32 top-10 h-80 w-80 rounded-full bg-rose blur-3xl opacity-30"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-sage blur-3xl opacity-20"
      />
      <div className="relative mx-auto max-w-5xl px-6 pt-20 pb-24 text-center lg:pt-28 lg:pb-32">
        <span className="inline-flex items-center gap-2 rounded-pill border border-sage/30 bg-surface/70 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.22em] text-sage">
          <span className="h-1.5 w-1.5 rounded-full bg-sage" />
          Future Intelligence · {COMPANY_REGION}
        </span>
        <h1 className="font-display mt-7 text-5xl font-semibold leading-[0.98] tracking-[-0.05em] text-ink sm:text-6xl lg:text-7xl">
          {COMPANY_NAME}
        </h1>
        <p className="mx-auto mt-7 max-w-2xl text-lg leading-8 text-muted">
          Exploring a more human future for artificial intelligence — shaped by curiosity, context, and connection.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#care"
            className="rounded-pill bg-sage px-7 py-3.5 font-semibold text-plum shadow-soft transition hover:bg-blush"
          >
            Explore the vision
          </a>
          <a
            href="#visit"
            className="rounded-pill border border-line bg-surface/70 px-7 py-3.5 font-semibold text-ink transition hover:border-sage hover:bg-surface"
          >
            View location
          </a>
        </div>

        <div className="mx-auto mt-16 grid max-w-4xl gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {PROFILE_FACTS.map((fact) => (
            <div
              key={fact.label}
              className="rounded-3xl border border-line/80 bg-surface/70 px-5 py-5 text-left backdrop-blur"
            >
              <p className="text-[11px] font-black uppercase tracking-[0.22em] text-sage">
                {fact.label}
              </p>
              <p className="font-display mt-2 text-xl text-ink">{fact.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
